import React, { Component } from 'react'
import Post from './Post'

import { db } from '../../firebase.js'

class Blog extends Component {
  constructor() {
    super()
    this.state = {
      posts: []
    }
  }

  componentWillMount() {
    const dbPosts = db.ref('posts')
    dbPosts.on('value', (snapshot) => {
      let posts = snapshot.val()
      let newState = []
      for (let post in posts) {
        newState.push({
          id: post,
          headline: posts[post].headline,
          bodytext: posts[post].bodytext,
          timestamp: posts[post].timestamp
        })
      }
      this.setState({
        posts: newState.sort((a, b) => {return b.timestamp - a.timestamp})
      })
    })
  }

  render() {
    return (
      <section className="w-100 bg-moon-gray flex flex-column">
        {this.state.posts.map( (post) => {
          return (
            <Post post={post} key={post.id}/>
          )
        })}
      </section>
    )
  }
}

export default Blog


// WEBPACK FOOTER //
// ./src/components/multi/Blog.js